import { render } from "./_learning-map.vue?vue&type=template&id=27ac261c&ts=true"
import script from "./_learning-map.vue?vue&type=script&lang=ts"
export * from "./_learning-map.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__